{
  "validation.required": "{{label}} er et obligatorisk felt",
  "validation.minLength": "{{label}} må bestå av minst {{min}} tegn",
  "validation.maxLength": "{{label}} kan ikke være lengre enn {{max}} tegn",
  "validation.contentTypeAlphanumeric": "{{label}} må være alfanumerisk",
  "validation.contentTypeDate": "{{label}} må være en dato",
  "validation.contentTypeDateBefore": "{{label}} må være en dato før {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} må være en dato etter {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} må være en dato og et klokkeslett",
  "validation.contentTypeDatetimeBefore": "{{label}} må være en dato før {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} må være en dato etter {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} må være en e-post",
  "validation.contentTypeInteger": "{{label}} må være et tall",
  "validation.contentTypeNumber": "{{label}} må være et tall",
  "validation.contentTypeRegex": "{{label}} har feil format",
  "validation.contentTypeText": "{{label}} må være en tekst",
  "validation.contentTypeTime": "{{label}} må være en tid",
  "validation.contentTypeUrl": "{{label}} må være en nettadresse",
  "select-element.default-option": "Å velge…",
  "button-element.network-required": "Du er for øyeblikket frakoblet. Opprett en nettverkstilkobling for å fortsette."
}